import moment from "moment";
export const formatDate = (date: Date) => {
  return moment(date).format("DD-MM-YYYY");

  const _d = date.toISOString();

  return _d.split("T")[0].split("-").reverse().join("-");

  //return `${_d.getFullYear()}-${_d.getMonth() + 1}-${_d.getDate()}`
};

export const endOfDayDate = (date: Date) => {
  return moment(date).add(1, "day");
};

export const formatSecondsToDate = (_t: any) => {
  //let m = moment.unix(_t);

  return moment.unix(_t).utc().format("DD-MM-YYYY hh:mm:ss A");
};
